"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var is_number_1 = require("./is-number");
var isEven = function (num) {
    return is_number_1.default(num) && num % 2 === 0;
};
exports.default = isEven;
//# sourceMappingURL=is-even.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/is-even.js
// module id = 1118
// module chunks = 37